'use strict';

var _ = require('lodash');
var ConfigurationFoMarketsTransformerFactory = function ConfigurationFoMarketsTransformerFactory(DataTransformer, momentService) {
  function ConfigurationFoMarketsTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-fo-markets-mode';
  }
  ConfigurationFoMarketsTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationFoMarketsTransformer.constructor = ConfigurationFoMarketsTransformer;
  ConfigurationFoMarketsTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationFoMarketsTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationFoMarketsTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationFoMarketsTransformer.prototype.transform = function (data) {
    var markets = data.domain.markets;
    var result = [];
    for (var i = 0; i < markets.length; i++) {
      var market = markets[i];
      for (var j = 0; j < market.benchmarkDetails.length; j++) {
        var transformedMarket = getTransformedMarket(market, market.benchmarkDetails[j]);
        result.push(_.cloneDeep(transformedMarket));
      }
    }
    return result;
  };
  function getTransformedMarket(market, benchmarkDetails) {
    var transformedMarket = {};
    transformedMarket.hostCarrier = market.hostCarrier;
    transformedMarket.fareTariffCode = market.fareTariffCode;
    transformedMarket.fareTariffNumber = market.fareTariffNumber;
    transformedMarket.originAirport = market.origin;
    transformedMarket.destinationAirport = market.destination;
    transformedMarket.foCabin = market.cabinCode;
    transformedMarket.marketListCategory = market.category;
    transformedMarket.foPos = market.pos;
    transformedMarket.benchmarkCarrier = benchmarkDetails.benchmarkCarrier.join(',');
    transformedMarket.hostFareTypeIndicator = benchmarkDetails.hostFareTypeIndicator;
    transformedMarket.benchmarkFareTypeIndicator = benchmarkDetails.benchmarkFareTypeIndicator;
    transformedMarket.approvedDaysOfWeek = benchmarkDetails.approvedDaysOfWeek;
    transformedMarket.exclusionReasons = benchmarkDetails.exclusionReasons;
    transformedMarket.fareSource = benchmarkDetails.fareSource;
    transformedMarket.approvedMarket = benchmarkDetails.approvedMarket;
    transformedMarket.marketTier = market.marketTier;
    transformedMarket.upsellCategory = market.upsellCategory;
    transformedMarket.fareChange = market.fareChange;
    transformedMarket.minFareChangePercentage = market.minFareChangePercentage;
    transformedMarket.maxFareChangePercentage = market.maxFareChangePercentage;
    transformedMarket.checkEntryLevelFareChange = market.checkEntryLevelFareChange;
    transformedMarket.adjustedTravelDates = market.adjustedTravelDates;
    transformedMarket.generateNewCancel = market.generateNewCancel;
    transformedMarket.marketGroup = market.marketGroup;
    transformedMarket.marketType = market.marketType;
    transformedMarket.marketAnalyst = market.marketAnalyst;
    transformedMarket.marketCategory = market.marketCategory;
    transformedMarket.lastUpdatedBy = market.lastUpdatedBy;
    transformedMarket.lastUpdatedAt = momentService.of(market.lastUpdatedAt, momentService.FIELD.LAST_UPDATED_AT);
    return transformedMarket;
  }
  return ConfigurationFoMarketsTransformer;
};
ConfigurationFoMarketsTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = ConfigurationFoMarketsTransformerFactory;